import parse from 'date-fns/parse';
import { api } from 'repositories/api';
import { OrderCodeModel } from 'models';
import { DAYS_IN_WEEK, ORDER_API_DATE_FORMAT } from 'helpers';

export class OrderHelper {
    public async getLastOrderCode(username: string, excludeExpiration = false): Promise<OrderCodeModel | null> {
        const maxAgeDays = DAYS_IN_WEEK;

        const orders = await api.hybris.getOrders(username);

        if (orders.length === 0) {
            return null;
        }

        const lastOrder = orders.max(o => (this.parseDate(o.placed).getTime()));

        if (excludeExpiration) {
            return { orderCode: lastOrder.code, basketId: lastOrder.guid };
        }

        let todaysDate = new Date();
        let latestDate = todaysDate.setDate(todaysDate.getDate() - maxAgeDays);
        let placedDate = this.parseDate(lastOrder.placed).getTime();

        if (latestDate < placedDate) {
            return { orderCode: lastOrder.code, basketId: lastOrder.guid };
        }

        return null;
    }

    private parseDate(date: string): Date {
        return parse(date, ORDER_API_DATE_FORMAT, new Date());
    }
}

export const orderHelper = new OrderHelper();